import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { RichText } from "../../../../../components/RichText";
import { CopyToClipboard } from "../../../../../components/CopyToClipboard";
import { usePageMetadata } from "../../../../../context/PageMetadata";
import { BETA_BASE_ROUTE } from "../../../functional/constants";
const PromoInviteContent = ({ title, description, links, inviteCode }) => {
    const { locale } = usePageMetadata();
    const richText = description;
    const [inviteLink, setInviteLink] = useState("");
    useEffect(() => {
        const origin = window.location.origin;
        setInviteLink(`${origin}${BETA_BASE_ROUTE}/${locale}/invite?code=${inviteCode}`);
    }, [locale, inviteCode]);
    return (React.createElement("div", null,
        title && (React.createElement("p", { "data-testid": "mediapromoinvite-title", className: "title" }, title)),
        description && (React.createElement("div", { "data-testid": "mediapromoinvite-description", className: "description" },
            React.createElement(RichText, { ...richText }))),
        links && links[0] && inviteLink && (React.createElement(CopyToClipboard, { description: links[0].title || "", item: inviteLink, successText: links[0].accessibilityText || "Copied" }))));
};
export const BetaInviteMediaPromoContent = styled(PromoInviteContent) ``;
//# sourceMappingURL=BetaInviteMediaPromoContent.js.map